import { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toastVisible, setToastVisible] = useState(false);

  const showToast = () => setToastVisible(true);
  const hideToast = () => setToastVisible(false);

  return (
    <ToastContext.Provider value={{ toastVisible, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};
